import {
  configureProductDucks,
  CARD_PRODUCT,
  PERSONAL_SAVINGS_ACCOUNT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
} from '@americanexpress/product-ducks';
import updateProductLocale from './utils/updateProductLocale';

const productTypes = [
  CARD_PRODUCT,
  PERSONAL_CHECKING_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  PERSONAL_SAVINGS_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
  INVESTMENT_ACCOUNT,
  CRYPTO_ACCOUNT,
];

const memberProducts = () => {
  configureProductDucks({
    getToState: (state) => state.getIn(['modules', 'axp-doc-communications-root', 'products']),
    defaultTypes: [CARD_PRODUCT, PERSONAL_SAVINGS_ACCOUNT],
    filterTypes: productTypes,
    orderTypes: productTypes,
    onLoadProducts: updateProductLocale,
    onAfterSelectProduct: updateProductLocale,
  });
};

memberProducts();

export default memberProducts;
